var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSummary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 59,
    viewBox: "0 0 49 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.22132 0.121952C2.69912 0.475353 1.22552 1.71736 0.494721 3.23956L0.0441216 4.18935L0.00752177 29.0354C-0.0170782 45.6722 0.0195218 54.0758 0.104722 54.4658C0.445522 56.0732 1.65152 57.5474 3.24692 58.3022L4.18472 58.7528L23.7327 58.7894C36.7767 58.814 43.4751 58.7774 43.8651 58.6922C45.8259 58.2782 47.6283 56.4998 48.0795 54.539C48.1647 54.1856 48.2133 48.242 48.2133 37.6826C48.2133 21.9836 48.2013 21.338 47.9817 20.8754C47.6895 20.2664 27.7401 0.304352 27.2283 0.109955C26.8017 -0.0484467 4.89152 -0.0364456 4.22132 0.121952ZM23.2455 11.534C23.2455 20.1326 23.2575 20.2424 23.9397 21.4238C24.4755 22.337 25.4619 23.2142 26.4975 23.7134L27.4473 24.164L36.0093 24.2006L44.5593 24.2372V39.2054C44.5593 50.5568 44.5227 54.2468 44.4129 54.4904C44.0961 55.1966 45.3021 55.16 24.0981 55.16C2.89412 55.16 4.09952 55.1966 3.78332 54.4904C3.55172 54.0032 3.57632 4.67715 3.80792 4.26315C4.16132 3.62955 3.88112 3.65416 13.9047 3.64215H23.2461V11.534H23.2455ZM35.3031 20.5466C27.1917 20.5712 27.2769 20.5832 27.0213 19.889C26.9481 19.706 26.8995 16.5764 26.8995 12.131V4.67715L34.8159 12.5936L42.7323 20.51L35.3031 20.5466Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0391 32.0168V33.8438H24.0967H36.1543V32.0168V30.1897H24.0967H12.0391V32.0168Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0391 39.9386V41.7656H24.0967H36.1543V39.9386V38.1116H24.0967H12.0391V39.9386Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0391 47.6105V49.4375H17.7637H23.4877V47.6105V45.7835H17.7637H12.0391V47.6105Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSummary);
export default __webpack_public_path__ + "static/media/summary.5461266b6daabf77ceb95f7e6762af18.svg";
export { ForwardRef as ReactComponent };